import { StyleSheet, View, Image, Text, TouchableOpacity, ImageBackground } from 'react-native';
import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";


const Ingredients:{
    [key: number]: {
        name: string,
        isCorect: boolean,
        default?: boolean,
    }[]
} = {
    
    1: [
        {
            name: 'ceai negru',
            isCorect: false,    
            default: true,
    },
    {
        name:'piersici',
        isCorect: false,
    },
    {
        name:'ceai verde',
        isCorect: false,
    },
    {
        name:'pepene',
        isCorect: false,
    },
    {
        name: 'fructe de pădure',
        isCorect: true,
    },
    {
        name: 'lămâie',
        isCorect: false,
    },
    {
        name: 'mango',
        isCorect: false,
    }
],

2: [
    {
        name: 'ceai negru',
        isCorect: false, 
        default: true,
},
{
    name:'piersici',
    isCorect: false,
},
{
    name:'ceai verde',
    isCorect: false,
},
{
    name:'pepene',
    isCorect: false,
},
{
    name: 'fructe de pădure',
    isCorect: false,
},
{
    name: 'lămâie',
    isCorect: false,
},
{
    name: 'mango',
    isCorect: true,
},
{
    name: 'ananas',
    isCorect: false,
        default: true,

},
],
    3: [
        {
            name: 'ceai negru',
            isCorect: false,    
        default: true,

    },
    {
        name:'piersici',
        isCorect: false,
    },
    {
        name:'ceai verde',
        isCorect: false,
    },
    {
        name:'pepene',
        isCorect: true,
    },
    {
        name: 'fructe de pădure',
        isCorect: false,
    },
    {
        name: 'lămâie',
        isCorect: false,
    },
    {
        name: 'mango',
        isCorect: false,
    },
    {
        name: 'mentă',
        isCorect: false,   
        default: true,

 
    }   
],
    4: [
            {
                name: 'ceai negru',
            isCorect: false,    
        default: true,
                
        },
        {
            name:'piersici',
            isCorect: false,
        },
        {
            name:'ceai verde',
            isCorect: false,
        },
        {
            name:'pepene',
            isCorect: false,
        },
        {
            name: 'fructe de pădure',
            isCorect: false,
        },
        {
            name: 'lămâie',
            isCorect: true,
        },
        {
            name: 'mango',
            isCorect: false,
        },
        {
            name: 'citronelă',
            isCorect: false,
        default: true,


        },    
],
5: [
    {
        name:'ceai verde',
        isCorect: false,
        default: true,


    },
    {
        name: 'lămâie verde',
        isCorect: true,    
        default: false,
},
{
    name:'piersici',
    isCorect: false,
},

{
    name:'pepene',
    isCorect: false,
},
{
    name: 'fructe de pădure',
    isCorect: false,
},

{
    name: 'mango',
    isCorect: false,
},
{
    name: 'mentă',
    isCorect: false,
        default: true,


},    
],
    

6: [
    {
        name: 'ceai negru',
        isCorect: false,   
        default: true,
        
},
{
    name:'piersici',
    isCorect: true,
},
{
    name:'ceai verde',
    isCorect: false,
},
{
    name:'pepene',
    isCorect: false,
},
{
    name: 'fructe de pădure',
    isCorect: false,
},
{
    name: 'lămâie',
    isCorect: false,
},
{
    name: 'mango',
    isCorect: false,
},
{
    name: 'hibiscus',
    isCorect: false,
        default: true,

}, 
],
    
};
            



const Drinks = [
    {
        img: require('../assets/screens/1-q.png'),
        img2: require('../assets/screens/1-w.png'),
    },
    {
        img: require('../assets/screens/2-q.png'),
        img2: require('../assets/screens/2-w.png'),
    },
    {
        img: require('../assets/screens/3-q.png'),
        img2: require('../assets/screens/3-w.png'),
    },
    {
        img: require('../assets/screens/4-q.png'),
        img2: require('../assets/screens/4-w.png'),
    },
    {
        img: require('../assets/screens/5-q.png'),
        img2: require('../assets/screens/5-w.png'),
    },
    {
        img: require('../assets/screens/6-q.png'),
        img2: require('../assets/screens/6-w.png'),
    },
    ]

const Quiz = ({isWrong, isOk, selectedNo}: {
  isOk(): void,
  selectedNo: number,
  isWrong(): void}) => {
  
  const [selected, setSelected] = useState<any[]>([]);
  const [selectedItems, setSelectedImtes] = useState<string[]>([]);
  const [totalWrong, setTotalWrong] = useState<number>(0);
  const [selectedDrink, setSelectedDrink] = useState<number>(-1);
  const [allChoses, setAllChoses] = useState<any[]>(Ingredients[selectedNo]);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [allItems, setAllItems] = useState<number>(0);
  const checkLocalStorage = async () => {
    const storedArray = await AsyncStorage.getItem('randomArray');
    if (storedArray) {
        const parsedArray = JSON.parse(storedArray);
        const items:  number[] = parsedArray.array  ;
        const selectedIndex = Math.floor(Math.random() * items.length);
      
      console.log('items',items.length)
      setAllItems(items.length);

       setSelectedIndex(selectedIndex);
      setSelectedDrink(items[selectedIndex])
    }
    
  }
  useEffect(() => {
    
    checkLocalStorage().catch(() => {
    
    })
  
  },[])
  
  const removeItemValue = async ()=>{
    const storedArray = await AsyncStorage.getItem('randomArray');
    if (storedArray) {
      const parsedArray = JSON.parse(storedArray);
      const items:  number[] = parsedArray.array  ;

      delete items[0];
      const newItems = items.filter((item) => item !== undefined);
        const newItemsObj = {
          ...parsedArray,
            array: newItems
        }
        await AsyncStorage.setItem('randomArray', JSON.stringify(newItemsObj));
      setSelectedIndex(-1);
      
    }
    
    
    
    
    
  }
  const selectDrink = Drinks[selectedNo -1];;
  const selectIngredients = Ingredients[selectedNo];
  const totalCorect = allChoses.filter((item) => item.corect).length;
  return <View style={styles.container}>
      <View  style={{...styles.logoW, backgroundColor: '#099b43'}}>

      <Image
        style={styles.logo}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/logo.png')}
      />
    </View>
    <View  style={styles.containerQuiz}>

    <View  style={{...styles.containerw, marginTop: '3%', marginBottom: '3%'}}>
    <Image
                  style={{
                      ...styles.centerImage,
                      width: 529,
                      height:131
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/text-2.png')}
        />
</View>
<View style={styles.quizView}>
    <View style={styles.imgInfo}>
<Image
             style={styles.imgInfoAbsolute}
             resizeMode="contain"
             resizeMethod="auto"
             source={selectDrink.img}
           />

</View>
<View style={styles.quizAnswer}>
        {selectIngredients.map((item, index) => {
            let backgroundColor = '#fff';
            let color = '#00a547';
            let borderColor = '#00a547';
            if (selectedItems.includes(item.name)) {
                if (item.isCorect) {
                    backgroundColor = '#00a547';
                    color = '#fff';
                }   else{
                    backgroundColor = '#ff0000';
                    borderColor = '#ff0000';
                    color = '#fff';
                }
            }
            if(item.default) {
                color = '#b8cd70';
                backgroundColor = '#00a547';
            }

            return <TouchableOpacity
            key={index}
            style={{
                backgroundColor: backgroundColor,
                borderRadius: 7,
                alignSelf: 'center',
                borderColor,
                borderWidth: 2,
                flex:1,
                height: 60,
                width:320,
                marginBottom:'3%',
                marginTop:'1%',
                alignItems: 'center',
                
                justifyContent:'center',
            }}
          
            onPress={() => {
                if(item.default) return;
                if(selectedItems.includes(item.name)) {
                  return;
                  }
              
              setSelectedImtes([...selectedItems, item.name]);
              if(item.isCorect) {
                    const prevSelected = [...selected];
                              prevSelected.push(item);
                              setSelected(prevSelected);
                             
                  const totalC = Ingredients[selectedNo].filter((item) => item.isCorect).length;
                              if(prevSelected.length === totalC) {
                                isOk();
                                removeItemValue().catch(() => {
                                });
                              }
                
              } else {
                const l = totalWrong + 1;
                if(l < 3) {
                  setTotalWrong(totalWrong + 1);
                }
                else {
                  isWrong();
                }
                
                  }
            }}
            >
                   <Text
                    style={{
                        color,
                        fontSize: 20,
                        fontFamily: 'Agriculture',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                           fontWeight: "bold",
                    }}
                    >
                        {item.name}</Text>

            </TouchableOpacity>
        })}
</View>


</View>

    </View>
    <View  style={styles.containerLast}>
            <View style={{
                position: 'absolute',
                top: -60,
                right: '12%',

          }}>
              { totalWrong === 2 ? (
                    <Text
                        style={{
                            alignContent: 'center',
                            fontSize: 29,
                            color: '#099b43',
                            fontFamily: 'Agriculture',
                      fontWeight: 'bold',
                            
                            textAlign: 'center',
                        }}
                  > {`mai ai o încercare`} </Text>
              )
                  : (
                      
                        <Text
                        style={{
                            alignContent: 'center',
                            fontSize: 29,
                            color: '#099b43',
                            fontFamily: 'Agriculture',
                      fontWeight: 'bold',
                            
                            textAlign: 'center',
                        }}
                    > {`mai ai ${3 - totalWrong} încercări`} </Text>
                  )
                    }
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
              >
                    {Array.from(Array(3 - totalWrong).keys()).map((item, index) => (
                                <Image
                                style={{
                                    width: 50,
                                    height: 50,
                                }}
                                resizeMode="contain"
                                resizeMethod="resize"
                                source={require('../assets/frunza.png')}
                                />
                    ))}
                       
                    </View>
        </View>

        <Image
           style={{
            ...styles.centerImage,
            height: 74,
            width: 627
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/cups.png')}
        />
  
    </View>
  </View>
}

const styles = StyleSheet.create({
    container: {
      width:'100%',
      minHeight:1280,
      backgroundColor: '#b8cd70',
    },
    containerQuiz:{
        width:'100%',
        minHeight:780,
        backgroundColor: '#fff',
    },
    logoW:{
    
  
        },
            logo:{
     alignSelf: 'center',
    width: 800,
    height:126,
    },
    containerw:{
      flex:1,
      position:'relative',
      width:'100%',
      zIndex: 1,
    },
    button:{
      backgroundColor:'#00a547',
      borderRadius: 7,
      alignSelf: 'center',
      flex:1,
      height: 60,
  
      width:280,
      marginBottom:'10%',
      marginTop:'3%',
      alignItems:'center',
      justifyContent:'center',
    },
    text:{
      fontSize: 42,
      color: '#fff',
      fontWeight: 'bold',
      alignSelf: 'center',
      marginTop:'7%',
      paddingBottom:'0%',
      lineHeight: 50,
      marginBottom:'1%',
      fontFamily: 'Agriculture',
    },
    centerImage:{
      alignSelf: 'center',
    },
    imgInfo:{
        height: 650,
        position: 'relative',
        marginLeft: '10%',
        width: 300,
    },
    imgInfoAbsolute:{
        height: 826,
        width:269,
        position: 'absolute',
        top: 0,
        left: 0,
    },
    buttonText: {
      color: '#fff',
      fontSize: 34,
      fontFamily: 'Agriculture',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    quizView:{
        alignItems:'flex-start',
        height: 730,
        marginTop: 10,
        marginBottom: 10,
        flexDirection: 'row',
      },
      quizAnswer:{
        width:'60%',
        flex: 1,
        height: 520,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
      },
    containerLast:{
        backgroundColor:'#b8cd70',
         width:'100%',
         verticalAlign:'bottom',
         flex:1,
         flexDirection: 'column',
         paddingTop: '6%',
         height: 136,
         marginTop: '9%',
     },
  });
  export default  Quiz;
  